import type { Doctor } from "@/types/content";

// Doctor information sourced from the existing orthospine.care website.
// Qualifications are shown as a clearly editable placeholder until the clinic confirms them.
//
// To replace the doctor photograph, simply change the `image` value below to your
// own image path or URL. No component changes are required.
export const doctors: Doctor[] = [
  {
    slug: "dr-n-ajit-kumar",
    name: "Dr. N. Ajit Kumar",
    designation: "Senior Consultant – Orthopaedic & Spine Surgery",
    // Add the doctor's confirmed degrees here (e.g. "MBBS, MS (Orthopaedics)"). Left empty until confirmed.
    qualification: "",
    specialty: "Orthopaedic & Spine Surgery",
    affiliation: "Senior Consultant Spine Surgeon, SUHAM Hospitals",
    experience: "10+ years of surgical experience · 2000+ spine surgeries",
    bio: "Dr. N. Ajit Kumar is known for his patient-centric approach to the treatment of trauma, joint disorders and various spine-related diseases. He is well trained in handling complex trauma, joint replacement, and complex and revision spine surgeries, and brings a calm, clear and honest communication style to every consultation.",
    detailedProfile: [
      "Dr. N. Ajit Kumar is a Senior Consultant in Orthopaedic and Spine Surgery based in Srirangam, Tiruchirappalli (Trichy). His practice covers the full range of spine disorders, joint disorders, tendon injuries, bone conditions and complex trauma.",
      "He is well trained in handling complex trauma, joint replacement, and complex and revision spine surgeries. He currently serves as a Senior Consultant Spine Surgeon at SUHAM Hospitals.",
      "His approach centres on accurate diagnosis and honest, patient-friendly communication. Non-surgical treatment is considered first wherever it is appropriate, and surgery is recommended only when it offers a clear benefit for the patient.",
    ],
    expertise: [
      "Complex trauma surgery",
      "Joint replacement for arthritis",
      "Complex spine surgery",
      "Revision spine surgery",
      "Minimally invasive spine procedures",
      "Arthroscopy for ligament injuries",
    ],
    image: "https://storage.helloreaddy.io/project_files/afe7bf6d-1a42-42e3-a1b8-8dc30048a3f0/f334d67d-5810-4325-9e00-5d6e70a0e5a2_compressed_WhatsApp-Image-2022-11-11-at-21.00.02.webp",
    imageAlt: "Dr. N. Ajit Kumar, Senior Consultant in Orthopaedic and Spine Surgery in Trichy",
  },
];